module.exports = __webpack_public_path__ + "img/truck.599ed8d0.svg";